__turbopack_context__.v({
  "item": "navigation-module-scss-module___cZw1G__item",
  "label": "navigation-module-scss-module___cZw1G__label",
  "root": "navigation-module-scss-module___cZw1G__root",
  "separator": "navigation-module-scss-module___cZw1G__separator",
});
